import { User } from 'dashboard/models/user';
import { UserActions, UserActionType } from 'dashboard/redux/actions/user';

export interface UserState {
  users: User[];
}

export const initialUserState: UserState = {
  users: [],
};

export default (state: UserState = initialUserState, action: UserActions) => {
  switch (action.type) {
    case UserActionType.SetUsers: {
      return {
        ...state,
        users: action.payload.users,
      };
    }
    case UserActionType.SetUser: {
      const userIndex = state.users.findIndex((user) => {
        return user.id === action.payload.user.id;
      });

      const updatedUsers = [...state.users];
      if (userIndex !== -1) {
        updatedUsers[userIndex] = action.payload.user;
      } else {
        updatedUsers.push(action.payload.user);
      }

      return {
        ...state,
        users: updatedUsers,
      };
    }

    default:
      return state;
  }
};
